import { gql } from '@apollo/client'

const RETRY_MENU_CURATION_TASK_LABELS_AND_INGREDIENTS_MUTATION = gql`
  mutation retryMenuCurationTaskLabelsAndIngredients($id: ID!) {
    retryMenuCurationTaskLabelsAndIngredients(id: $id)
  }
`

export default RETRY_MENU_CURATION_TASK_LABELS_AND_INGREDIENTS_MUTATION
